import { heFetch } from './HeFetch';
var GeoRestrictions = /** @class */ (function () {
    function GeoRestrictions() {
    }
    // BFF contract: GET /geo-restrictions/resolve?context&locale&locationIds (repeated) (EX-1526)
    GeoRestrictions.resolve = function (locationIds, context, locale) {
        var params = new URLSearchParams({ context: context, locale: locale });
        locationIds.forEach(function (locationId) { return params.append('locationIds', locationId); });
        return heFetch.get("/geo-restrictions/resolve?".concat(params.toString()));
    };
    return GeoRestrictions;
}());
export default GeoRestrictions;
